export default "__VITE_ASSET__2JtLh1R5__"